import { z } from 'zod';

export const termsAndConditionsTypes = z.enum([
  'GENERAL_TERMS',
  'DATA_RETENTION',
  'CREDIT_STATUS',
]);

export type TermsAndConditionsType = z.infer<typeof termsAndConditionsTypes>;

export const termsAndConditionsSchema = z.object({
  tc_type: termsAndConditionsTypes,
  version: z.string(),
  title: z.string(),
  modal_title: z.string(),
  body: z.string(),
  action_label: z.string(),
  _id: z.string(),
  _publish_on: z.string(),
});

export type TermsAndConditions = z.infer<typeof termsAndConditionsSchema>;
